// extracted by mini-css-extract-plugin
module.exports = {"body":"_1mCmUqP","button":"_3JAbzP8"};